var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-alert',{attrs:{"type":"warning","text":"","outlined":""}},[_c('span',{staticClass:"title"},[_vm._v("Erro 404. Página não localizada")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }